import {Injectable} from '@angular/core';
import {TidUserProfile} from '../models/user-profile.model';
import {BehaviorSubject} from 'rxjs';
import * as moment from 'moment-timezone';

@Injectable()
export class UserService {
  tidUserProfile = new BehaviorSubject<TidUserProfile>(null);

  constructor() {
  }

  getLocale(): string {
    return this.getTidUserProfile()?.language ?? 'en-GB';
  }

  getTimezone(): string {
    const timeZoneCode = this.getTidUserProfile()?.timeZone;
    return this.interpretTimeZone(timeZoneCode) ?? 'CET';
  }

  private interpretTimeZone(timeZoneCode: string): string {
    const timeZones = moment.tz.names();
    return timeZones.includes(timeZoneCode) ? timeZoneCode : null;
  }

  getTidUserProfile() {
    return this.tidUserProfile.getValue();
  }
}
